import type { IncidentStatus } from "@/api/types";
import { Badge } from "@/components/ui/badge";

export function StatusBadge({ value }: { value: IncidentStatus }) {
  if (value === "open") {
    return (
      <Badge variant="outline" data-testid="status-badge" data-status="open">
        Abierto
      </Badge>
    );
  }
  if (value === "needs_human") {
    return (
      <Badge
        data-testid="status-badge"
        data-status="needs_human"
        className="bg-amber-500 text-white hover:bg-amber-500"
      >
        Requiere intervención
      </Badge>
    );
  }
  return (
    <Badge variant="secondary" data-testid="status-badge" data-status="resolved">
      Resuelto
    </Badge>
  );
}
